var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRank20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 125,
  height: 103,
  viewBox: "0 0 125 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_1_403)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_1_403)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M56.228 76L58.114 66.816H36.22C36.712 65.75 37.532 64.438 38.844 62.962C40.156 61.486 41.796 59.928 43.928 58.288L51.8 52.22C53.932 50.58 55.9 48.858 57.54 47.136C59.18 45.496 60.656 43.692 61.804 41.806C62.952 40.002 63.772 38.034 64.346 35.984C64.838 33.934 65.166 31.72 65.166 29.26C65.166 25.652 63.936 22.864 61.558 20.896C59.18 18.928 55.49 17.944 50.57 17.944C44.174 17.944 39.336 19.42 35.892 22.29C32.448 25.242 30.152 29.342 29.004 34.754L28.512 36.968H39.828C40.156 35.492 40.484 34.016 40.976 32.622C41.386 31.31 41.96 30.08 42.616 29.014C43.272 28.03 44.092 27.21 45.076 26.554C46.06 25.98 47.29 25.652 48.766 25.652C51.8 25.652 53.358 27.21 53.358 30.162C53.358 30.654 53.276 31.064 53.276 31.474C53.194 31.966 53.112 32.376 53.03 32.868C52.702 34.426 52.292 35.738 51.964 36.886C51.554 38.034 51.062 39.018 50.406 40.002C49.75 40.986 48.93 41.97 47.946 42.954C46.962 43.938 45.65 45.004 44.174 46.152L38.516 50.58C35.892 52.548 33.596 54.516 31.628 56.484C29.66 58.452 27.938 60.42 26.462 62.388C24.986 64.438 23.756 66.57 22.772 68.784C21.788 70.998 20.968 73.376 20.476 76H56.228ZM65.4504 48.94C64.7944 51.892 64.3844 54.598 64.0564 56.976C63.7284 59.354 63.5644 61.486 63.5644 63.372C63.5644 68.292 64.6304 71.818 66.9264 73.95C69.1404 76.082 72.7484 77.148 77.8324 77.148C82.0964 77.148 85.7044 76.328 88.4924 74.606C91.2804 72.884 93.5764 70.588 95.3804 67.718C97.1844 64.848 98.5784 61.568 99.6444 57.796C100.628 54.106 101.612 50.252 102.432 46.152C103.006 43.2 103.498 40.576 103.826 38.116C104.154 35.656 104.318 33.442 104.318 31.474C104.318 26.718 103.17 23.274 100.956 21.142C98.7424 19.01 95.1344 17.944 90.1324 17.944C85.7864 17.944 82.2604 18.846 79.4724 20.568C76.6844 22.29 74.3884 24.586 72.5844 27.456C70.7804 30.326 69.3044 33.606 68.2384 37.378C67.1724 41.15 66.2704 45.004 65.4504 48.94ZM76.7664 51.482L78.0784 45.168C78.8164 41.478 79.5544 38.362 80.2924 35.82C80.9484 33.36 81.6864 31.31 82.5064 29.834C83.2444 28.358 84.0644 27.292 85.0484 26.636C86.0324 25.98 87.1804 25.652 88.4924 25.652C89.9684 25.652 91.1164 26.062 91.8544 26.8C92.5924 27.62 93.0024 29.014 93.0024 31.064C93.0024 33.77 92.3464 37.952 91.1984 43.61L89.8864 49.924C89.0664 53.696 88.3284 56.812 87.6724 59.272C86.9344 61.814 86.1964 63.864 85.3764 65.34C84.5564 66.816 83.7364 67.882 82.7524 68.538C81.7684 69.194 80.7024 69.44 79.3904 69.44C77.8324 69.44 76.6844 69.112 76.0284 68.374C75.2904 67.636 74.9624 66.242 74.9624 64.11C74.9624 61.404 75.5364 57.222 76.7664 51.482Z",
  fill: "#FAFAFA"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_1_403",
  x: -1,
  y: 0.94397,
  width: 125.318,
  height: 101.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_403"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1_403",
  result: "effect2_dropShadow_1_403"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_1_403",
  result: "effect3_dropShadow_1_403"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_403",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_1_403",
  x: 16.476,
  y: 17.944,
  width: 91.8425,
  height: 67.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_403"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_403",
  result: "shape"
})))));
export default SvgRank20;